module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('h1', [_vm._v(_vm._s(_vm.title))]), _c('div', {
    attrs: {
      "id": "container"
    }
  }, [_c('CompDemo', {
    attrs: {
      "demoProps": _vm.demoProps
    }
  }), _c('div', {
    staticClass: "divider"
  }), _c('CompCtrl', {
    attrs: {
      "demoProps": _vm.demoProps
    }
  })], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-329ede01"}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Container.vue
// module id = 97
// module chunks = 1